// extracted by css-extract-rspack-plugin
export default {"descriptionIcon":"eHmKL"};